import { render, staticRenderFns } from "./workshops-form.vue?vue&type=template&id=9438619e&scoped=true"
import script from "./workshops-form.vue?vue&type=script&lang=js"
export * from "./workshops-form.vue?vue&type=script&lang=js"
import style0 from "./workshops-form.vue?vue&type=style&index=0&id=9438619e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9438619e",
  null
  
)

export default component.exports